import { FAQ_LIST } from "./types";

export const faqList = (onSuccess, onError) => {
  return {
    type: FAQ_LIST,
    onSuccess,
    onError,
  };
};
